import { bool, func, node, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';
import ButtonLink from 'ravenjs/lib/Button/ButtonLink';
import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';

import { accessControl } from 'modules/acl';

const TypographyStyled = styled(Typography)`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const SidebarOption = ({ icon, text, onClick, disabled }) => {
    return (
        <ButtonLink color="secondary" onClick={onClick} disabled={disabled}>
            <Typography type="caption">
                <Row padding="0" margin="0">
                    <Col size={{ md: 2 }}>{icon}</Col>
                    <Col size={{ md: 10 }}>
                        <TypographyStyled
                            disabled={disabled}
                            type="sidebarOption"
                            color="sidebarOption"
                        >
                            {text}
                        </TypographyStyled>
                    </Col>
                </Row>
            </Typography>
        </ButtonLink>
    );
};

SidebarOption.propTypes = {
    disabled: bool,
    icon: node,
    text: string,
    onClick: func.isRequired,
};

SidebarOption.defaultProps = {
    disabled: false,
    icon: null,
    text: '',
};

export default accessControl(SidebarOption);
